export default __webpack_public_path__ + "static/media/renfil.f0976b3c.svg";